module.exports = __webpack_public_path__ + "static/img/surface9.feac116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface9.png
// module id = zzJR
// module chunks = 2